<template>
  <div class="loading-overlay">
    <div class="loader-container">
      <img
        src="@/assets/icons/loader.gif"
        alt="Cargando..."
        class="loading-gif"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingIndicator",
};
</script>

<style scoped>
/* Contenedor a pantalla completa */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9); /* Fondo blanco con ligera transparencia */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* Contenedor del GIF */
.loader-container {
  width: 200px; /* Ajusta este tamaño según prefieras */
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Estilo de la imagen GIF */
.loading-gif {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* Opcional: Una suave transición de entrada para que no aparezca de golpe */
.loading-overlay {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>